var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "lg": "6",
      "sm": "12"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Basic Form")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('b-link', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-1",
            modifiers: {
              "collapse-1": true
            }
          }],
          staticClass: "text-primary float-right"
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi vulputate, ex ac venenatis mollis, diam nibh finibus leo")]), _c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-1"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "form-1"
          }
        }, [_vm._v("                    "), _c('code', [_vm._v("\n <b-form>\n  <b-form-group label=\"Email address:\" label-for=\"email1\">\n    <b-form-input id=\"email1\" type=\"email\"></b-form-input>\n  </b-form-group>\n  <b-form-group label=\"Password:\" label-for=\"pwd\">\n    <b-form-input id=\"pwd\" type=\"password\" ></b-form-input>\n  </b-form-group>\n  <b-form-checkbox class=\"mb-3\">\n    Remember me\n  </b-form-checkbox>\n  <b-button type=\"submit\" variant=\"primary\">Submit</b-button>\n  <b-button type=\"submit\" variant=\"none\" class=\"iq-bg-danger ml-3\">Cancle</b-button>\n</b-form>\n")])])])])]), _c('b-form', [_c('b-form-group', {
          attrs: {
            "label": "Email address:",
            "label-for": "email1"
          }
        }, [_c('b-form-input', {
          attrs: {
            "id": "email1",
            "type": "email"
          }
        })], 1), _c('b-form-group', {
          attrs: {
            "label": "Password:",
            "label-for": "pwd"
          }
        }, [_c('b-form-input', {
          attrs: {
            "id": "pwd",
            "type": "password"
          }
        })], 1), _c('b-form-checkbox', {
          staticClass: "mb-3"
        }, [_vm._v(" Remember me ")]), _c('b-button', {
          attrs: {
            "type": "submit",
            "variant": "primary"
          }
        }, [_vm._v("Submit")]), _c('b-button', {
          staticClass: "iq-bg-danger ml-3",
          attrs: {
            "type": "submit",
            "variant": "none"
          }
        }, [_vm._v("Cancle")])], 1)];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Form Grid")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('b-link', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-2",
            modifiers: {
              "collapse-2": true
            }
          }],
          staticClass: "text-primary float-right"
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi vulputate, ex ac venenatis mollis, diam nibh finibus leo")]), _c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-2"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "form-2"
          }
        }, [_vm._v("                    "), _c('code', [_vm._v("\n<b-form>\n  <b-row>\n    <b-col>\n      <b-form-input type=\"text\" placeholder=\"First Name\"></b-form-input>\n    </b-col>\n    <b-col>\n      <b-form-input type=\"text\" placeholder=\"Last Name\"></b-form-input>\n    </b-col>\n  </b-row>\n</b-form>\n")])])])])]), _c('b-form', [_c('b-row', [_c('b-col', [_c('b-form-input', {
          attrs: {
            "type": "text",
            "placeholder": "First Name"
          }
        })], 1), _c('b-col', [_c('b-form-input', {
          attrs: {
            "type": "text",
            "placeholder": "Last Name"
          }
        })], 1)], 1)], 1)];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Input")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('b-link', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-3",
            modifiers: {
              "collapse-3": true
            }
          }],
          staticClass: "text-primary float-right"
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi vulputate, ex ac venenatis mollis, diam nibh finibus leo")]), _c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-3"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "form-3"
          }
        }, [_vm._v("                    "), _c('code', [_vm._v("\n<b-form>\n  <b-form-group label=\"Input Text \" label-for=\"exampleInputText1\">\n    <b-form-input id=\"exampleInputText1\" type=\"text\" placeholder=\"Enter Name\" value=\"Mark Jhon\"></b-form-input>\n  </b-form-group>\n  <b-form-group label=\"Email Input \" label-for=\"exampleInputText3\">\n    <b-form-input id=\"exampleInputText3\" type=\"email\" value=\"markjhon@gmail.com\" placeholder=\"Enter Email\"></b-form-input>\n  </b-form-group>\n  <b-form-group label=\"Url Input\" label-for=\"exampleInputurl\">\n    <b-form-input id=\"exampleInputurl\" type=\"url\" value=\"https://getbootstrap.com\" placeholder=\"Enter Url\"></b-form-input>\n  </b-form-group>\n  <b-form-group label=\"Telephone Input\" label-for=\"exampleInputphone\">\n    <b-form-input id=\"exampleInputphone\" type=\"tel\" value=\"1-(555)-555-5555\"></b-form-input>\n  </b-form-group>\n  <b-form-group label=\"Number Input\" label-for=\"exampleInputNumber1\">\n    <b-form-input id=\"exampleInputNumber1\" type=\"number\" value=\"2356\"></b-form-input>\n  </b-form-group>\n  <b-form-group label=\"Password Input\" label-for=\"exampleInputPassword3\">\n    <b-form-input id=\"exampleInputPassword3\" type=\"password\" value=\"markjhon123\" placeholder=\"Enter Password\" ></b-form-input>\n  </b-form-group>\n  <b-form-group label=\"Date Input\" label-for=\"exampleInputdate\">\n    <b-form-input id=\"exampleInputdate\" type=\"date\" value=\"2019-12-18\"></b-form-input>\n  </b-form-group>\n  <b-form-group label=\"Month Input\" label-for=\"exampleInputmonth\">\n    <b-form-input id=\"exampleInputmonth\" type=\"month\" value=\"2019-12\"></b-form-input>\n  </b-form-group>\n  <b-form-group label=\"Week Input\" label-for=\"exampleInputweek\">\n    <b-form-input id=\"exampleInputweek\" type=\"week\" value=\"2019-W46\"></b-form-input>\n  </b-form-group>\n  <b-form-group label=\"Time Input\" label-for=\"exampleInputtime\">\n    <b-form-input id=\"exampleInputtime\" type=\"time\" value=\"13:45\"></b-form-input>\n  </b-form-group>\n  <b-form-group label=\"Date and Time Input\" label-for=\"exampleInputdatetime\">\n    <b-form-input id=\"exampleInputdatetime\" type=\"datetime-local\" value=\"2019-12-19T13:45:00\"></b-form-input>\n  </b-form-group>\n  <b-form-group label=\"Example textarea\" label-for=\"exampleFormControlTextarea1\">\n    <b-form-textarea id=\"exampleFormControlTextarea1\" rows=\"5\"></b-form-textarea>\n  </b-form-group>\n  <b-form-checkbox class=\"mb-3\">\n    Remember me\n  </b-form-checkbox>\n  <b-button type=\"submit\" variant=\"primary\">Submit</b-button>\n  <b-button type=\"submit\" variant=\"none\" class=\"iq-bg-danger ml-3\">Cancle</b-button>\n</b-form>\n")])])])])]), _c('b-form', [_c('b-form-group', {
          attrs: {
            "label": "Input Text ",
            "label-for": "exampleInputText1"
          }
        }, [_c('b-form-input', {
          attrs: {
            "id": "exampleInputText1",
            "type": "text",
            "placeholder": "Enter Name",
            "value": "Mark Jhon"
          }
        })], 1), _c('b-form-group', {
          attrs: {
            "label": "Email Input ",
            "label-for": "exampleInputText3"
          }
        }, [_c('b-form-input', {
          attrs: {
            "id": "exampleInputText3",
            "type": "email",
            "value": "markjhon@gmail.com",
            "placeholder": "Enter Email"
          }
        })], 1), _c('b-form-group', {
          attrs: {
            "label": "Url Input",
            "label-for": "exampleInputurl"
          }
        }, [_c('b-form-input', {
          attrs: {
            "id": "exampleInputurl",
            "type": "url",
            "value": "https://getbootstrap.com",
            "placeholder": "Enter Url"
          }
        })], 1), _c('b-form-group', {
          attrs: {
            "label": "Telephone Input",
            "label-for": "exampleInputphone"
          }
        }, [_c('b-form-input', {
          attrs: {
            "id": "exampleInputphone",
            "type": "tel",
            "value": "1-(555)-555-5555"
          }
        })], 1), _c('b-form-group', {
          attrs: {
            "label": "Number Input",
            "label-for": "exampleInputNumber1"
          }
        }, [_c('b-form-input', {
          attrs: {
            "id": "exampleInputNumber1",
            "type": "number",
            "value": "2356"
          }
        })], 1), _c('b-form-group', {
          attrs: {
            "label": "Password Input",
            "label-for": "exampleInputPassword3"
          }
        }, [_c('b-form-input', {
          attrs: {
            "id": "exampleInputPassword3",
            "type": "password",
            "value": "markjhon123",
            "placeholder": "Enter Password"
          }
        })], 1), _c('b-form-group', {
          attrs: {
            "label": "Date Input",
            "label-for": "exampleInputdate"
          }
        }, [_c('b-form-input', {
          attrs: {
            "id": "exampleInputdate",
            "type": "date",
            "value": "2019-12-18"
          }
        })], 1), _c('b-form-group', {
          attrs: {
            "label": "Month Input",
            "label-for": "exampleInputmonth"
          }
        }, [_c('b-form-input', {
          attrs: {
            "id": "exampleInputmonth",
            "type": "month",
            "value": "2019-12"
          }
        })], 1), _c('b-form-group', {
          attrs: {
            "label": "Week Input",
            "label-for": "exampleInputweek"
          }
        }, [_c('b-form-input', {
          attrs: {
            "id": "exampleInputweek",
            "type": "week",
            "value": "2019-W46"
          }
        })], 1), _c('b-form-group', {
          attrs: {
            "label": "Time Input",
            "label-for": "exampleInputtime"
          }
        }, [_c('b-form-input', {
          attrs: {
            "id": "exampleInputtime",
            "type": "time",
            "value": "13:45"
          }
        })], 1), _c('b-form-group', {
          attrs: {
            "label": "Date and Time Input",
            "label-for": "exampleInputdatetime"
          }
        }, [_c('b-form-input', {
          attrs: {
            "id": "exampleInputdatetime",
            "type": "datetime-local",
            "value": "2019-12-19T13:45:00"
          }
        })], 1), _c('b-form-group', {
          attrs: {
            "label": "Example textarea",
            "label-for": "exampleFormControlTextarea1"
          }
        }, [_c('b-form-textarea', {
          attrs: {
            "id": "exampleFormControlTextarea1",
            "rows": "5"
          }
        })], 1), _c('b-form-checkbox', {
          staticClass: "mb-3"
        }, [_vm._v(" Remember me ")]), _c('b-button', {
          attrs: {
            "type": "submit",
            "variant": "primary"
          }
        }, [_vm._v("Submit")]), _c('b-button', {
          staticClass: "iq-bg-danger ml-3",
          attrs: {
            "type": "submit",
            "variant": "none"
          }
        }, [_vm._v("Cancle")])], 1)];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Input Size")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('b-link', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-4",
            modifiers: {
              "collapse-4": true
            }
          }],
          staticClass: "text-primary float-right"
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi vulputate, ex ac venenatis mollis, diam nibh finibus leo")]), _c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-4"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "form-4"
          }
        }, [_vm._v("                    "), _c('code', [_vm._v("\n<b-form>\n  <b-form-group label=\"Small\" label-for=\"colFormLabelSm\">\n    <b-form-input type=\"email\" size=\"sm\" id=\"colFormLabelSm\" placeholder=\"form-control-sm\"></b-form-input>\n  </b-form-group>\n  <b-form-group label=\"Default\" label-for=\"colFormLabel\" class=\"mb-0\">\n    <b-form-input type=\"email\" id=\"colFormLabel\" placeholder=\"form-control\"></b-form-input>\n  </b-form-group>\n  <b-form-group label=\"Large\" label-for=\"colFormLabelLg\">\n    <b-form-input type=\"email\" size=\"lg\" id=\"colFormLabelLg\" placeholder=\"form-control-lg\"></b-form-input>\n  </b-form-group>\n</b-form>\n")])])])])]), _c('b-form', [_c('b-form-group', {
          attrs: {
            "label": "Small",
            "label-for": "colFormLabelSm"
          }
        }, [_c('b-form-input', {
          attrs: {
            "type": "email",
            "size": "sm",
            "id": "colFormLabelSm",
            "placeholder": "form-control-sm"
          }
        })], 1), _c('b-form-group', {
          staticClass: "mb-0",
          attrs: {
            "label": "Default",
            "label-for": "colFormLabel"
          }
        }, [_c('b-form-input', {
          attrs: {
            "type": "email",
            "id": "colFormLabel",
            "placeholder": "form-control"
          }
        })], 1), _c('b-form-group', {
          attrs: {
            "label": "Large",
            "label-for": "colFormLabelLg"
          }
        }, [_c('b-form-input', {
          attrs: {
            "type": "email",
            "size": "lg",
            "id": "colFormLabelLg",
            "placeholder": "form-control-lg"
          }
        })], 1)], 1)];
      },
      proxy: true
    }])
  })], 1), _c('b-col', {
    attrs: {
      "lg": "6",
      "sm": "12"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Horizontal Form")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('b-link', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-5",
            modifiers: {
              "collapse-5": true
            }
          }],
          staticClass: "text-primary float-right"
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi vulputate, ex ac venenatis mollis, diam nibh finibus leo")]), _c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-5"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "form-5"
          }
        }, [_vm._v("                    "), _c('code', [_vm._v("\n<b-form>\n  <b-form-group\n    class=\"row\"\n    label-cols-sm=\"2\"\n    label=\"Email:\"\n    label-for=\"email\"\n  >\n    <b-form-input id=\"email\" placeholder=\"Enter Your email\"></b-form-input>\n  </b-form-group>\n  <b-form-group\n    class=\"row\"\n    label-cols-sm=\"2\"\n    label=\"Password:\"\n    label-for=\"pwd1\"\n  >\n    <b-form-input id=\"pwd1\" placeholder=\"Enter Your password\"></b-form-input>\n  </b-form-group>\n  <b-form-group>\n    <b-form-checkbox>Remember me</b-form-checkbox>\n  </b-form-group>\n  <b-button type=\"submit\" variant=\"primary\">Submit</b-button>\n  <b-button type=\"submit\" variant=\"none\" class=\"iq-bg-danger ml-3\">Cancle</b-button>\n</b-form>\n")])])])])]), _c('b-form', [_c('b-form-group', {
          staticClass: "row",
          attrs: {
            "label-cols-sm": "2",
            "label": "Email:",
            "label-for": "email"
          }
        }, [_c('b-form-input', {
          attrs: {
            "id": "email",
            "placeholder": "Enter Your email"
          }
        })], 1), _c('b-form-group', {
          staticClass: "row",
          attrs: {
            "label-cols-sm": "2",
            "label": "Password:",
            "label-for": "pwd1"
          }
        }, [_c('b-form-input', {
          attrs: {
            "id": "pwd1",
            "placeholder": "Enter Your password"
          }
        })], 1), _c('b-form-group', [_c('b-form-checkbox', [_vm._v("Remember me")])], 1), _c('b-button', {
          attrs: {
            "type": "submit",
            "variant": "primary"
          }
        }, [_vm._v("Submit")]), _c('b-button', {
          staticClass: "iq-bg-danger ml-3",
          attrs: {
            "type": "submit",
            "variant": "none"
          }
        }, [_vm._v("Cancle")])], 1)];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Form row")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('b-link', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-6",
            modifiers: {
              "collapse-6": true
            }
          }],
          staticClass: "text-primary float-right"
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi vulputate, ex ac venenatis mollis, diam nibh finibus leo")]), _c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-6"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "form-6"
          }
        }, [_vm._v("                    "), _c('code', [_vm._v("\n<b-form-row>\n  <b-col>\n    <b-form-input type=\"text\" placeholder=\"First Name\"></b-form-input>\n  </b-col>\n  <b-col>\n    <b-form-input type=\"text\" placeholder=\"Last Name\"></b-form-input>\n  </b-col>\n</b-form-row>\n")])])])])]), _c('b-form-row', [_c('b-col', [_c('b-form-input', {
          attrs: {
            "type": "text",
            "placeholder": "First Name"
          }
        })], 1), _c('b-col', [_c('b-form-input', {
          attrs: {
            "type": "text",
            "placeholder": "Last Name"
          }
        })], 1)], 1)];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Input")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('b-link', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-7",
            modifiers: {
              "collapse-7": true
            }
          }],
          staticClass: "text-primary float-right"
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi vulputate, ex ac venenatis mollis, diam nibh finibus leo")]), _c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-7"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "form-7"
          }
        }, [_vm._v("                    "), _c('code', [_vm._v("\n<b-form>\n  <b-form-group\n    label-for=\"exampleInputDisabled1\"\n    label=\"Disabled Input\">\n    <b-form-input type=\"text\" id=\"exampleInputDisabled1\" value=\"Mark Jhon\" disabled></b-form-input>\n  </b-form-group>\n  <b-form-group\n    label-for=\"exampleInputPlaceholder\"\n    label=\"Placeholder\">\n    <b-form-input type=\"text\" id=\"exampleInputPlaceholder\" placeholder=\"This is Placeholder\"></b-form-input>\n  </b-form-group>\n  <b-form-group\n    label-for=\"exampleInputReadonly\"\n    label=\"Readonly\">\n    <b-form-input type=\"text\" id=\"exampleInputReadonly\" value=\"Mark Jhon\" readonly></b-form-input>\n  </b-form-group>\n  <b-form-group\n    label-for=\"exampleInputcolor\"\n    label=\"Input color\">\n    <b-form-input type=\"color\" id=\"exampleInputcolor\" value=\"#1c67a2\"></b-form-input>\n  </b-form-group>\n  <b-form-group\n    label-for=\"exampleFormControlSelect1\"\n    label=\"Select Input\">\n    <b-form-select plain v-model=\"selected\" :options=\"options1\" id=\"exampleFormControlSelect1\">\n      <template v-slot:first>\n        <b-form-select-option :value=\"null\" disabled>Select your age</b-form-select-option>\n      </template>\n    </b-form-select>\n  </b-form-group>\n  <b-form-group\n    label-for=\"exampleFormControlSelect2\"\n    label=\"Example multiple select\">\n    <b-form-select plain v-model=\"selected\" multiple :options=\"options2\" id=\"exampleFormControlSelect2\">\n    </b-form-select>\n  </b-form-group>\n  <b-form-group\n    label-for=\"customRange1\"\n    label=\"Range Input\">\n    <b-form-input id=\"customRange1\" type=\"range\"></b-form-input>\n  </b-form-group>\n  <b-form-group>\n    <b-form-checkbox>Default checkbox</b-form-checkbox>\n    <b-form-checkbox v-model=\"checked1\">Checked</b-form-checkbox>\n    <b-form-checkbox disabled>Disabled checkbox</b-form-checkbox>\n    <b-form-checkbox v-model=\"checked2\" disabled >Disabled checkbox</b-form-checkbox>\n  </b-form-group>\n  <b-form-group>\n    <b-form-checkbox inline>Default checkbox</b-form-checkbox>\n    <b-form-checkbox v-model=\"checked3\" inline>Checked</b-form-checkbox>\n    <b-form-checkbox disabled inline>Disabled checkbox</b-form-checkbox>\n    <b-form-checkbox v-model=\"checked2\" disabled inline>Disabled checkbox</b-form-checkbox>\n  </b-form-group>\n  <b-form-group>\n    <b-form-radio v-model=\"radio1\" name=\"customRadio\">Default radio</b-form-radio>\n    <b-form-radio v-model=\"radio1\" name=\"customRadio\">Default radio</b-form-radio>\n    <b-form-radio v-model=\"radio3\" name=\"customRadio3\">Selected radio</b-form-radio>\n    <b-form-radio disabled name=\"customRadio4\">disabled radio</b-form-radio>\n    <b-form-radio disabled v-model=\"radio5\" name=\"customRadio5\">Selected and  disabled radio</b-form-radio>\n  </b-form-group>\n  <b-form-group>\n    <b-form-radio inline v-model=\"radio2\" name=\"customRadio1\">Default radio</b-form-radio>\n    <b-form-radio inline v-model=\"radio2\" name=\"customRadi1\">Default radio</b-form-radio>\n    <b-form-radio inline v-model=\"radio6\" name=\"customRadio6\">Selected radio</b-form-radio>\n    <b-form-radio inline v-model=\"radio7\" disabled name=\"customRadio7\">disabled radio</b-form-radio>\n    <b-form-radio inline disabled v-model=\"radio8\" name=\"customRadio8\">Selected and  disabled radio</b-form-radio>\n  </b-form-group>\n  <b-form-group>\n    <b-form-checkbox name=\"check-button\" switch>Toggle this switch element</b-form-checkbox>\n    <b-form-checkbox v-model=\"switch1\" name=\"check-button\" switch>Toggle this switch element</b-form-checkbox>\n    <b-form-checkbox disabled name=\"check-button\" switch>Disabled switch element</b-form-checkbox>\n  </b-form-group>\n  <b-form-group\n    label-for=\"exampleFormControlFile1\"\n    label=\"Example file input\"\n  >\n    <b-form-file plain id=\"exampleFormControlFile1\"></b-form-file>\n  </b-form-group>\n  <b-form-group\n    label-for=\"customFile\"\n  >\n    <b-form-file\n      placeholder=\"Choose a file\"\n      id=\"customFile\"\n    ></b-form-file>\n  </b-form-group>\n  <b-button type=\"submit\" variant=\"primary\">Submit</b-button>\n  <b-button type=\"submit\" variant=\"none\" class=\"iq-bg-danger ml-3\">Cancle</b-button>\n</b-form>\n")])])])])]), _c('b-form', [_c('b-form-group', {
          attrs: {
            "label-for": "exampleInputDisabled1",
            "label": "Disabled Input"
          }
        }, [_c('b-form-input', {
          attrs: {
            "type": "text",
            "id": "exampleInputDisabled1",
            "value": "Mark Jhon",
            "disabled": ""
          }
        })], 1), _c('b-form-group', {
          attrs: {
            "label-for": "exampleInputPlaceholder",
            "label": "Placeholder"
          }
        }, [_c('b-form-input', {
          attrs: {
            "type": "text",
            "id": "exampleInputPlaceholder",
            "placeholder": "This is Placeholder"
          }
        })], 1), _c('b-form-group', {
          attrs: {
            "label-for": "exampleInputReadonly",
            "label": "Readonly"
          }
        }, [_c('b-form-input', {
          attrs: {
            "type": "text",
            "id": "exampleInputReadonly",
            "value": "Mark Jhon",
            "readonly": ""
          }
        })], 1), _c('b-form-group', {
          attrs: {
            "label-for": "exampleInputcolor",
            "label": "Input color"
          }
        }, [_c('b-form-input', {
          attrs: {
            "type": "color",
            "id": "exampleInputcolor",
            "value": "#1c67a2"
          }
        })], 1), _c('b-form-group', {
          attrs: {
            "label-for": "exampleFormControlSelect1",
            "label": "Select Input"
          }
        }, [_c('b-form-select', {
          attrs: {
            "plain": "",
            "options": _vm.options1,
            "id": "exampleFormControlSelect1"
          },
          scopedSlots: _vm._u([{
            key: "first",
            fn: function fn() {
              return [_c('b-form-select-option', {
                attrs: {
                  "value": null,
                  "disabled": ""
                }
              }, [_vm._v("Select your age")])];
            },
            proxy: true
          }]),
          model: {
            value: _vm.selectedAge,
            callback: function callback($$v) {
              _vm.selectedAge = $$v;
            },
            expression: "selectedAge"
          }
        })], 1), _c('b-form-group', {
          attrs: {
            "label-for": "exampleFormControlSelect2",
            "label": "Example multiple select"
          }
        }, [_c('b-form-select', {
          attrs: {
            "plain": "",
            "multiple": "",
            "options": _vm.options2,
            "id": "exampleFormControlSelect2"
          },
          model: {
            value: _vm.selected,
            callback: function callback($$v) {
              _vm.selected = $$v;
            },
            expression: "selected"
          }
        })], 1), _c('b-form-group', {
          attrs: {
            "label-for": "customRange1",
            "label": "Range Input"
          }
        }, [_c('b-form-input', {
          attrs: {
            "id": "customRange1",
            "type": "range"
          }
        })], 1), _c('b-form-group', [_c('b-form-checkbox', [_vm._v("Default checkbox")]), _c('b-form-checkbox', {
          model: {
            value: _vm.checked1,
            callback: function callback($$v) {
              _vm.checked1 = $$v;
            },
            expression: "checked1"
          }
        }, [_vm._v("Checked")]), _c('b-form-checkbox', {
          attrs: {
            "disabled": ""
          }
        }, [_vm._v("Disabled checkbox")]), _c('b-form-checkbox', {
          attrs: {
            "disabled": ""
          },
          model: {
            value: _vm.checked2,
            callback: function callback($$v) {
              _vm.checked2 = $$v;
            },
            expression: "checked2"
          }
        }, [_vm._v("Disabled checkbox")])], 1), _c('b-form-group', [_c('b-form-checkbox', {
          attrs: {
            "inline": ""
          }
        }, [_vm._v("Default checkbox")]), _c('b-form-checkbox', {
          attrs: {
            "inline": ""
          },
          model: {
            value: _vm.checked3,
            callback: function callback($$v) {
              _vm.checked3 = $$v;
            },
            expression: "checked3"
          }
        }, [_vm._v("Checked")]), _c('b-form-checkbox', {
          attrs: {
            "disabled": "",
            "inline": ""
          }
        }, [_vm._v("Disabled checkbox")]), _c('b-form-checkbox', {
          attrs: {
            "disabled": "",
            "inline": ""
          },
          model: {
            value: _vm.checked2,
            callback: function callback($$v) {
              _vm.checked2 = $$v;
            },
            expression: "checked2"
          }
        }, [_vm._v("Disabled checkbox")])], 1), _c('b-form-group', [_c('b-form-radio', {
          attrs: {
            "name": "customRadio"
          },
          model: {
            value: _vm.radio1,
            callback: function callback($$v) {
              _vm.radio1 = $$v;
            },
            expression: "radio1"
          }
        }, [_vm._v("Default radio")]), _c('b-form-radio', {
          attrs: {
            "name": "customRadio"
          },
          model: {
            value: _vm.radio1,
            callback: function callback($$v) {
              _vm.radio1 = $$v;
            },
            expression: "radio1"
          }
        }, [_vm._v("Default radio")]), _c('b-form-radio', {
          attrs: {
            "name": "customRadio3",
            "value": "true"
          },
          model: {
            value: _vm.radio6,
            callback: function callback($$v) {
              _vm.radio6 = $$v;
            },
            expression: "radio6"
          }
        }, [_vm._v("Selected radio")]), _c('b-form-radio', {
          attrs: {
            "disabled": "",
            "name": "customRadio4"
          }
        }, [_vm._v("disabled radio")]), _c('b-form-radio', {
          attrs: {
            "disabled": "",
            "name": "customRadio5",
            "value": "true"
          },
          model: {
            value: _vm.radio6,
            callback: function callback($$v) {
              _vm.radio6 = $$v;
            },
            expression: "radio6"
          }
        }, [_vm._v("Selected and disabled radio")])], 1), _c('b-form-group', [_c('b-form-radio', {
          attrs: {
            "inline": "",
            "name": "customRadio1"
          },
          model: {
            value: _vm.radio2,
            callback: function callback($$v) {
              _vm.radio2 = $$v;
            },
            expression: "radio2"
          }
        }, [_vm._v("Default radio")]), _c('b-form-radio', {
          attrs: {
            "inline": "",
            "name": "customRadio1"
          },
          model: {
            value: _vm.radio2,
            callback: function callback($$v) {
              _vm.radio2 = $$v;
            },
            expression: "radio2"
          }
        }, [_vm._v("Default radio")]), _c('b-form-radio', {
          attrs: {
            "inline": "",
            "name": "customRadio6",
            "value": "true"
          },
          model: {
            value: _vm.radio6,
            callback: function callback($$v) {
              _vm.radio6 = $$v;
            },
            expression: "radio6"
          }
        }, [_vm._v("Selected radio")]), _c('b-form-radio', {
          attrs: {
            "inline": "",
            "disabled": "",
            "name": "customRadio7"
          },
          model: {
            value: _vm.radio7,
            callback: function callback($$v) {
              _vm.radio7 = $$v;
            },
            expression: "radio7"
          }
        }, [_vm._v("disabled radio")]), _c('b-form-radio', {
          attrs: {
            "inline": "",
            "disabled": "",
            "name": "customRadio8",
            "value": "dissel"
          },
          model: {
            value: _vm.radio8,
            callback: function callback($$v) {
              _vm.radio8 = $$v;
            },
            expression: "radio8"
          }
        }, [_vm._v("Selected and disabled radio")])], 1), _c('b-form-group', [_c('b-form-checkbox', {
          attrs: {
            "name": "check-button",
            "switch": ""
          }
        }, [_vm._v("Toggle this switch element")]), _c('b-form-checkbox', {
          attrs: {
            "name": "check-button",
            "switch": ""
          },
          model: {
            value: _vm.switch1,
            callback: function callback($$v) {
              _vm.switch1 = $$v;
            },
            expression: "switch1"
          }
        }, [_vm._v("Toggle this switch element")]), _c('b-form-checkbox', {
          attrs: {
            "disabled": "",
            "name": "check-button",
            "switch": ""
          }
        }, [_vm._v("Disabled switch element")])], 1), _c('b-form-group', {
          attrs: {
            "label-for": "exampleFormControlFile1",
            "label": "Example file input"
          }
        }, [_c('b-form-file', {
          attrs: {
            "plain": "",
            "id": "exampleFormControlFile1"
          }
        })], 1), _c('b-form-group', {
          attrs: {
            "label-for": "customFile"
          }
        }, [_c('b-form-file', {
          attrs: {
            "placeholder": "Choose a file",
            "id": "customFile"
          }
        })], 1), _c('b-button', {
          attrs: {
            "type": "submit",
            "variant": "primary"
          }
        }, [_vm._v("Submit")]), _c('b-button', {
          staticClass: "iq-bg-danger ml-3",
          attrs: {
            "type": "submit",
            "variant": "none"
          }
        }, [_vm._v("Cancle")])], 1)];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Select Size")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('b-link', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-8",
            modifiers: {
              "collapse-8": true
            }
          }],
          staticClass: "text-primary float-right"
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi vulputate, ex ac venenatis mollis, diam nibh finibus leo")]), _c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-8"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "form-8"
          }
        }, [_vm._v("                    "), _c('code', [_vm._v("\n<b-form-group label=\"small\">\n  <b-form-select plain v-model=\"selected\" :options=\"options3\" size=\"sm\" class=\"mb-3\">\n    <template v-slot:first>\n      <b-form-select-option :value=\"null\">Open this select menu</b-form-select-option>\n    </template>\n  </b-form-select>\n</b-form-group>\n<b-form-group label=\"Default\">\n  <b-form-select plain v-model=\"selected\" :options=\"options3\" class=\"mb-3\">\n    <template v-slot:first>\n      <b-form-select-option :value=\"null\">Open this select menu</b-form-select-option>\n    </template>\n  </b-form-select>\n</b-form-group>\n<b-form-group label=\"Large\">\n  <b-form-select plain v-model=\"selected\" :options=\"options3\" size=\"lg\">\n    <template v-slot:first>\n      <b-form-select-option :value=\"null\">Open this select menu</b-form-select-option>\n    </template>\n  </b-form-select>\n</b-form-group>\n")])])])])]), _c('b-form-group', {
          attrs: {
            "label": "small"
          }
        }, [_c('b-form-select', {
          staticClass: "mb-3",
          attrs: {
            "plain": "",
            "options": _vm.options3,
            "size": "sm"
          },
          scopedSlots: _vm._u([{
            key: "first",
            fn: function fn() {
              return [_c('b-form-select-option', {
                attrs: {
                  "value": null
                }
              }, [_vm._v("Open this select menu")])];
            },
            proxy: true
          }]),
          model: {
            value: _vm.selected3,
            callback: function callback($$v) {
              _vm.selected3 = $$v;
            },
            expression: "selected3"
          }
        })], 1), _c('b-form-group', {
          attrs: {
            "label": "Default"
          }
        }, [_c('b-form-select', {
          staticClass: "mb-3",
          attrs: {
            "plain": "",
            "options": _vm.options3
          },
          scopedSlots: _vm._u([{
            key: "first",
            fn: function fn() {
              return [_c('b-form-select-option', {
                attrs: {
                  "value": null
                }
              }, [_vm._v("Open this select menu")])];
            },
            proxy: true
          }]),
          model: {
            value: _vm.selected3,
            callback: function callback($$v) {
              _vm.selected3 = $$v;
            },
            expression: "selected3"
          }
        })], 1), _c('b-form-group', {
          attrs: {
            "label": "Large"
          }
        }, [_c('b-form-select', {
          attrs: {
            "plain": "",
            "options": _vm.options3,
            "size": "lg"
          },
          scopedSlots: _vm._u([{
            key: "first",
            fn: function fn() {
              return [_c('b-form-select-option', {
                attrs: {
                  "value": null
                }
              }, [_vm._v("Open this select menu")])];
            },
            proxy: true
          }]),
          model: {
            value: _vm.selected3,
            callback: function callback($$v) {
              _vm.selected3 = $$v;
            },
            expression: "selected3"
          }
        })], 1)];
      },
      proxy: true
    }])
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }